"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _idCounter = 1;
/**
 * TextMoreLess Component
 * @example
 * <TextMoreLess truncatedLength={20}>Lorem ipsum dolor sit amet</TextMoreLess>
 */

var TextMoreLess = /*#__PURE__*/function (_React$Component) {
  _inherits(TextMoreLess, _React$Component);

  var _super = _createSuper(TextMoreLess);

  function TextMoreLess(props) {
    var _this;

    _classCallCheck(this, TextMoreLess);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_toggle", function (e) {
      if (e) {
        e.preventDefault();
      }

      _this.setState(function (state) {
        return {
          expanded: !state.expanded
        };
      });
    });

    _idCounter = _idCounter + 1;
    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(TextMoreLess, [{
    key: "render",
    value: function render() {
      if (this.props.children && this.props.children.length <= this.props.truncatedLength) {
        return this.props.children;
      }

      var id = "showhide-".concat(_idCounter);
      var body = null;

      if (this.state.expanded) {
        body = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          id: id
        }, this.props.children), /*#__PURE__*/_react.default.createElement("span", null, ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: "#",
          role: "button",
          onClick: this._toggle,
          "aria-hidden": true
        }, this.props.lessLabel)));
      } else {
        body = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          id: id
        }, this.props.children.substr(0, this.props.truncatedLength), "\u2026"), /*#__PURE__*/_react.default.createElement("span", null, ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: "#",
          role: "button",
          "aria-controls": id,
          onClick: this._toggle
        }, this.props.showLabel)));
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, body);
    }
  }]);

  return TextMoreLess;
}(_react.default.Component);

exports.default = TextMoreLess;

_defineProperty(TextMoreLess, "propTypes", {
  children: _propTypes.default.string,
  truncatedLength: _propTypes.default.number,
  showLabel: _propTypes.default.string,
  lessLabel: _propTypes.default.string
});

_defineProperty(TextMoreLess, "defaultProps", {
  children: '',
  truncatedLength: 160,
  showLabel: 'Show more',
  lessLabel: 'Show less'
});
//# sourceMappingURL=TextMoreLess.js.map